import { Link } from 'react-router-dom';
import { Icons } from '@/src/modules/components/Icons';
import { Button } from '@/src/modules/components/Button';
import { GradientButton } from '@/src/modules/components/ui/gradient-button';
import type { InvitationTab } from '@/src/types';

const COPY: Record<InvitationTab, { title: string; body: string }> = {
  all: {
    title: 'No invitations yet',
    body: 'Create your first invitation to get started.',
  },
  active: {
    title: 'No active invitations',
    body: 'When you publish an invitation it shows up here.',
  },
  inactive: {
    title: 'No inactive invitations',
    body: 'Expired, archived, and cancelled invitations live here.',
  },
  drafts: {
    title: 'No drafts',
    body: 'Half-finished invitations show up here so you can pick them back up.',
  },
  archived: {
    title: 'Nothing archived',
    body: 'Archived invitations are kept here for 90 days before being cleaned up.',
  },
};

export function InvitationEmptyState({ tab }: { tab: InvitationTab }) {
  const copy = COPY[tab];
  return (
    <div className="text-center py-16">
      <div className="w-16 h-16 rounded-full bg-surface-low mx-auto mb-4 flex items-center justify-center text-on-surface-variant">
        <Icons.Calendar size={32} />
      </div>
      <h3 className="text-xl font-bold text-on-surface mb-1">{copy.title}</h3>
      <p className="text-sm text-on-surface-variant mb-6">{copy.body}</p>
    </div>
  );
}
